import {
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';
import { EventService } from '@services/event-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Anomaly, Session } from 'src/app/queries/generated';

@Component({
  selector: 'lv-attendance-timeline-session',
  templateUrl: 'attendance-timeline-session.component.html',
  styleUrls: ['attendance-timeline-session.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [DatePipe]
})
export class AttendanceTimelineSessionComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<EventService>();
  private renderer = inject(Renderer2);
  private el = inject(ElementRef);
  private events = inject(EventService);

  @Input() session: Session;
  @Input() sessionCount: number;
  @Input() selectedAnomaly: Anomaly;

  @HostListener('mouseenter') mouseEnter() {
    this.events.publish('session:focus', this.session);
  }

  @HostListener('mouseleave') mouseLeave() {
    this.events.publish('session:focus');
  }

  ngOnInit() {
    // ng doesnt like css vars in hostbindings :(
    const buffer = 2;
    this.renderer.setAttribute(this.el.nativeElement, 'style', `--grow: ${buffer + this.sessionCount * buffer}`);

    this.events
      .of('session:focus')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((session) => {
        if (session && session !== this.session) {
          this.renderer.addClass(this.el.nativeElement, 'is-shrunk');
        } else {
          this.renderer.removeClass(this.el.nativeElement, 'is-shrunk');
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }
}
